<div class="fetal_medicine header_top">
  <div class="banner">
    <div class="container">
      <h6>Antenatal Interventions at NCare IVF</h6>
      <h5>Diagnosis & Care, In Utero</h5>
      <p>
        At NCare IVF, we offer a range of specialized prenatal procedures
        designed to diagnose, monitor, and manage complex fetal conditions
        during pregnancy.
      </p>
      <p>
        These tests help us better understand your baby’s health and, when
        needed, plan interventions early. All procedures are performed by
        experienced fetal medicine specialists in a safe, sterile environment
        using advanced ultrasound and imaging guidance.
      </p>
      <p>
        Whether it’s confirming a diagnosis, relieving a complication, or
        ensuring the safety of multiple babies, our goal is to support the
        healthiest outcome—for both you and your baby.
      </p>
    </div>
  </div>
  <div class="fm_sec">
    <div class="container">
      <div class="accordion">
        <!-- 1. Amniocentesis -->
        <div class="accordion-item">
          <input type="radio" name="accordion" id="amniocentesis" checked />
          <label for="amniocentesis">1. Amniocentesis</label>
          <div class="content">
            <p>
              <strong>What is amniocentesis?</strong><br />
              Amniocentesis is a diagnostic procedure where a small amount of
              amniotic fluid is taken from around the baby in the womb to test
              for chromosomal conditions, genetic disorders, or infections.
            </p>

            <p>
              <strong>When is it performed?</strong><br />
              Usually done between 15 and 20 weeks of pregnancy. It may also be
              performed later for specific concerns.
            </p>

            <p>
              <strong>How is it done?</strong><br />
              Using real-time ultrasound, a thin needle is carefully inserted
              through the abdomen into the amniotic sac to collect fluid.
            </p>

            <p>
              <strong>What conditions can it detect?</strong><br />
              It can detect genetic conditions - aneuploidies like down
              syndrome, spinal muscular atrophy, thalassemia and intrauterine
              infections.
            </p>

            <p>
              <strong>Is it safe?</strong><br />
              Yes. The risk of miscarriage is very less at 0.2 - 0.3 percent
            </p>

            <p>
              <strong>How soon are results available?</strong><br />
              The time it takes to receive your results will depend on what
              tests the lab needs to conduct on the amniotic fluid.<br />
              You may hear some information from your doctor as soon as 1 week
              after your test. Some test results may take 2 weeks or longer.
            </p>
          </div>
        </div>

        <!-- 2. CVS -->
        <div class="accordion-item">
          <input type="radio" name="accordion" id="cvs" />
          <label for="cvs">2. Chorionic Villus Sampling (CVS)</label>
          <div class="content">
            <p>
              <strong>What is CVS and why is it done?</strong><br />
              CVS is an early diagnostic test that collects a small sample of
              placental tissue to identify chromosomal or genetic abnormalities.
            </p>

            <p>
              <strong>When is CVS performed?</strong><br />
              Typically between 10 and 13 weeks, making it earlier than
              amniocentesis.
            </p>

            <p>
              <strong>How is the sample collected?</strong><br />
              The sample is taken through the cervix (transcervical) or through
              the abdomen (transabdominal), guided by ultrasound.
            </p>

            <p>
              <strong>What disorders can CVS detect?</strong><br />
              It can detect conditions like Down syndrome, cystic fibrosis,
              sickle cell anemia, and other inherited disorders.
            </p>

            <p>
              <strong>Is it safe?</strong><br />
              Yes. The risk of miscarriage is very less at 0.2 - 0.3 percent
            </p>

            <p>
              <strong>How soon are results available?</strong><br />
              The turnaround time for your results will depend on the type of
              tests the lab conducts on the placental biopsy.<br />
              You may hear some information from your doctor as soon as 1 week
              after your test. Some test results may take 2 weeks or longer.
            </p>
          </div>
        </div>

        <!-- 3. Amnioreduction -->
        <div class="accordion-item">
          <input type="radio" name="accordion" id="amnioreduction" />
          <label for="amnioreduction">3. Amnioreduction</label>
          <div class="content">
            <p>
              <strong>What is amnioreduction?</strong><br />
              Amnioreduction is a therapeutic procedure where excess amniotic
              fluid is drained from the womb to treat polyhydramnios or
              complications in twin pregnancies like TTTS.
            </p>

            <p>
              <strong>Why is it done?</strong><br />
              Too much fluid can cause maternal discomfort, preterm labour, and
              preterm premature rupture of membranes. Amnioreduction helps
              relieve pressure and balance fluid levels.
            </p>

            <p>
              <strong>How is the fluid removed?</strong><br />
              A needle is inserted through the abdomen under ultrasound guidance
              to drain a safe amount of amniotic fluid.
            </p>

            <p>
              <strong>Is this painful or risky?</strong><br />
              The procedure is usually well-tolerated with minimal discomfort.
              Risks are rare but include infection or mild contractions.
            </p>

            <p>
              <strong>Is it repeated?</strong><br />
              Yes, sometimes multiple sessions are needed depending on how the
              fluid re-accumulates.
            </p>
          </div>
        </div>

        <!-- 4. Cordocentesis -->
        <div class="accordion-item">
          <input type="radio" name="accordion" id="cordocentesis" />
          <label for="cordocentesis"
            >4. Cordocentesis / Fetal Blood Sampling</label
          >
          <div class="content">
            <p>
              <strong>What is cordocentesis?</strong><br />
              Also called Percutaneous Umbilical Blood Sampling (PUBS), this
              test involves taking a small blood sample directly from the baby’s
              umbilical cord.
            </p>

            <p>
              <strong>When is it used?</strong><br />
              Cordocentesis is used to diagnose infections, confirm chromosomal
              disorders, or assess fetal anemia or blood disorders.
            </p>

            <p>
              <strong>Can it be used for treatment too?</strong><br />
              Yes. Cordocentesis also allows intrauterine transfusions if the
              baby is anemic.
            </p>

            <p>
              <strong>Is it safe?</strong><br />
              In skilled hands, it is very safe. The procedure takes only a few
              minutes, and both mother and baby are monitored closely afterward.
            </p>

            <p>
              <strong>How soon are results available?</strong><br />
              Result timelines may vary depending on the tests required on the
              fetal blood obtained.<br />
              You may hear some information from your doctor as soon as 1 week
              after your test. Some test results may take 2 weeks or longer.
            </p>
          </div>
        </div>

        <!-- 5. Multifetal Reduction -->
        <div class="accordion-item">
          <input type="radio" name="accordion" id="multifetal" />
          <label for="multifetal">5. Multifetal Reduction</label>
          <div class="content">
            <p>
              <strong>What is multifetal reduction?</strong><br />
              This is a procedure used to reduce the number of fetuses in a
              multiple pregnancy, often done when three or more babies are
              present, or if one fetus has a severe abnormality.
            </p>

            <p>
              <strong>Why is it needed?</strong><br />
              Higher-order multiple pregnancies carry greater risks of premature
              delivery, miscarriage, and low birth weight. Reducing the number
              can improve outcomes for the remaining babies.
            </p>

            <p><strong>How is it done?</strong><br /></p>
            <ul>
              <li>
                In dichorionic pregnancies, a medication is injected into the
                targeted fetus under ultrasound guidance.
              </li>
              <li>
                In monochorionic pregnancies, cord occlusion methods (like RFA
                or bipolar coagulation) are used instead.
              </li>
            </ul>

            <p>
              <strong>Is it safe? </strong><br />
              Yes. The risk of miscarriage is very less at 0.2 - 0.3 percent
            </p>

            <p>
              <strong>Is the procedure emotionally difficult?</strong><br />
              Yes, and we understand. At Ncare, we offer emotional support and
              counseling to help you make informed, compassionate choices.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <section class="pink_bg_content mt-5">
    <div class="container">
      <div class="pink_bg_content_child">
        <h5>Get the Right Test, at the Right Time</h5>
        <p>
          Our fetal medicine team will guide you through every
          procedure—clearly, safely, and with care.
        </p>
        <button (click)="contactus()">Book an Appointment</button>
      </div>
    </div>
  </section>
  <div class="container">
    <div class="ncare-highlight">
      <h2>Your Pregnancy. Our Priority.</h2>
      <p>
        At <strong>NCare IVF Kannur, Kerala</strong>, we bring together expert
        clinicians, genetic counselors, fetal surgeons, and caring staff to
        support your journey at every stage.
      </p>
      <p>
        All procedures are performed in a dedicated fetal unit using world-class
        infrastructure and technology. We follow international safety protocols
        and place your well-being at the center of everything we do.
      </p>
      <p>
        If you've been recommended any prenatal test or treatment, our team is
        here to guide you with clarity, empathy, and the highest level of care.
      </p>
    </div>
  </div>
</div>
